import { NZAP_SEASONAL_DB, NZAP_SERVICE } from "../config";

export const parseJwt = (token: string): { [key: string]: unknown } => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const getTenantLoginOptions = (tenantName: string) => {
  const options = { tenantName };
  if (tenantName === 'nzap') {
    return {
      ...options,
      service: NZAP_SERVICE,
      seasonalDatabase: NZAP_SEASONAL_DB
    }
  } else {
    throw new Error("Invalid tenant name found.");

  }
}
